import angular from 'angular';

import UserModel from '../../models/user';

import AuthCodeModalCtrl from './auth-code.controller';
import AuthCodeModalConf from './auth-code.config';

export default angular.module('app.auth-code', [UserModel])
	.controller('AuthCodeModalCtrl', AuthCodeModalCtrl)
	.constant('AuthCodeModalConf', AuthCodeModalConf)
	.name;



// WEBPACK FOOTER //
// ./project/modals/auth-code/index.js